import { motion } from "framer-motion";
import { Quote, Star, ExternalLink } from "lucide-react";

const ease = [0.16, 1, 0.3, 1];

const GOOGLE_REVIEWS_URL =
  "https://www.google.com/search?sca_esv=0fbb8f91d07ef4fb&rlz=1C5GCEM_enCH1127CH1127&sxsrf=ANbL-n4ME2gSa6SjyvlvXQPH9k5rR3BVDw:1780061426224&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qOVZPBws-STeYU4uaGAbqBiCvkCFEgH_C3RNwIWKoD7rzsK39RftkoT3MP7E7C2SktpV4btCYwFPogcFxS6reAqoRRUGN&q=DEM+BAT+Avis&sa=X&ved=2ahUKEwi09fPHzd6UAxVZRv4FHakfDdsQ0bkNegQIOhAF";

export const Testimonials = () => {
  return (
    <section
      id="avis"
      data-testid="testimonials-section"
      className="bg-cream-alt py-24 sm:py-32 lg:py-40"
    >
      <div className="max-w-5xl mx-auto px-6 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease }}
          className="text-center"
        >
          <span className="eyebrow">Ce que disent nos clients</span>
          <h2 className="mt-4 font-serif text-charcoal text-4xl sm:text-5xl lg:text-6xl leading-[1.05] font-normal">
            La parole est <span className="italic text-bronze">à eux.</span>
          </h2>
        </motion.div>

        <motion.a
          href={GOOGLE_REVIEWS_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="testimonial-card"
          aria-label="Voir l'avis sur Google"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.9, ease, delay: 0.2 }}
          className="group block mt-16 lg:mt-20 relative bg-white p-10 lg:p-16 border border-border hover:border-bronze hover:shadow-[0_24px_60px_-20px_rgba(92,92,92,0.25)] transition-all duration-500"
        >
          <Quote
            className="absolute -top-5 left-10 w-12 h-12 text-bronze bg-cream-alt p-2"
            strokeWidth={1}
          />

          {/* Google badge top-right */}
          <div className="absolute top-6 right-6 flex items-center gap-2 text-charcoal-muted group-hover:text-bronze transition-colors">
            <span className="text-[10px] uppercase tracking-[0.3em] font-medium">Avis Google</span>
            <ExternalLink
              className="w-3.5 h-3.5 transition-transform duration-500 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
              strokeWidth={1.5}
            />
          </div>

          <div className="flex justify-center gap-1 mb-8">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-5 h-5 fill-bronze text-bronze" strokeWidth={0} />
            ))}
          </div>

          <blockquote className="font-serif text-charcoal text-xl sm:text-2xl lg:text-3xl leading-[1.35] font-normal italic text-center">
            « J'ai fait appel à leurs services pour refaire 2 pièces de mon appartement et j'ai été extrêmement satisfait du travail ! Un patron très sympathique et surtout très minutieux. Je les rappellerai bientôt ! »
          </blockquote>

          <figcaption className="mt-10 text-center not-italic">
            <div className="h-px w-12 bg-bronze mx-auto mb-4" />
            <div className="text-charcoal text-base font-medium">Antoine Gauthey</div>
            <div className="text-charcoal-muted text-xs uppercase tracking-widest mt-1">
              Client · Avis Google ★★★★★
            </div>
          </figcaption>

          {/* Hover hint */}
          <div className="mt-8 text-center text-bronze text-[11px] uppercase tracking-[0.3em] opacity-0 group-hover:opacity-100 translate-y-1 group-hover:translate-y-0 transition-all duration-500">
            Voir sur Google →
          </div>
        </motion.a>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-12 text-center"
        >
          <a
            href={GOOGLE_REVIEWS_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="testimonials-google-link"
            className="text-charcoal-muted text-sm font-light italic hover:text-bronze transition-colors"
          >
            Lire tous les avis sur Google →
          </a>
        </motion.div>
      </div>
    </section>
  );
};
